import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { setDispAccessLog, getAccessLog } from '../../actions/LogOutputAction';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import { LOGOUTPUT_ACTIONS } from '../../../common/const';
import './LogOutputChartComponent.css';

/**
 * アクセスログ画面コンポーネント
 */
class LogOutputChartComponent extends Component {
  componentDidMount() {
    this.callGetAccessLog();
  }

  callGetAccessLog = async () => {
    const { getAccessLogAct, setSystemLodingFLgAct } = this.props;
    setSystemLodingFLgAct(true);
    await getAccessLogAct();
    setSystemLodingFLgAct(false);
  }

  render() {
    const { dispAccessLog } = this.props;

    return (
      dispAccessLog && (
        <div className="chart">
          <ResponsiveContainer>
            <ComposedChart
              width={500}
              height={300}
              data={dispAccessLog}
              margin={{
                top: 5,
                right: 30,
                left: 10,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="date"
                interval={0}
              />
              <YAxis
                allowDecimals={false}
              />
              <Tooltip isAnimationActive={false} />
              <Legend verticalAlign="top" align="right" />
              <Bar dataKey="利用者数" barSize={20} fill="#2ac3c3" />
              <Line dataKey={LOGOUTPUT_ACTIONS.COMPANY} stroke="#79acdd" strokeWidth={2} />
              <Line dataKey={LOGOUTPUT_ACTIONS.TARGETING} stroke="#b93ade" strokeWidth={2} />
              <Line dataKey={LOGOUTPUT_ACTIONS.MATCHING} stroke="#d73751" strokeWidth={2} />
              <Line dataKey={LOGOUTPUT_ACTIONS.ADMIN} stroke="#525252" strokeWidth={2} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    targetYM: state.logoutput.targetYM,
    targetFunc: state.logoutput.targetFunc,
    accessLog: state.logoutput.accessLog,
    dispAccessLog: state.logoutput.dispAccessLog,
  }),
  (dispatch) => ({
    setDispAccessLogAct: (obj) => dispatch(setDispAccessLog(obj)),
    getAccessLogAct: (str) => dispatch(getAccessLog(str)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(LogOutputChartComponent);
